import React from 'react'


const About = () => {
  return (
    
    <section class="about" id="about">
        <div class="max-width ">
            {/* <h2 class="title">About us</h2> */}
            <div class="about-content">
                <div class="column left">
                <img src="assets/banner (2).jpg" alt="" className='ImageBanner' />
                </div>
                <div class="column right">
                    <div class="text1" style={{"fontWeight": "bolder", "color": "#893101" }}>MORE INFORMATION ABOUT THE COMPANY</div>
                    <p className='text-center' style={{ "color":"gray" }}><span className=''style={{"fontWeight": "bolder", "color": "#893101" }}>ORATECH</span> is a third party company in telecommunication industry  
                       playing a major role in distribution, offering affordable and the cheapest data, airtime, 
                       Dstv subscription, Gotv subscription, Startimes subscription, Spectranet subscription, 
                       smiles subscription, Electricity payment , Bulksms Service provider, phones, laptops, 
                       and accessories outlet platform. .</p>
                </div>
            </div>
        </div>
        <div class="max-width mt-4">
        
            <div class="about-content">
                <div class="column part px-2">
                <div className='cardoption'>
                  <div className='card'>
                  <img src="assets/auto.png" alt="" className='Imagell' />
                  <p className=''style={{"font-size":"20px", "margin-left":"15px", "font-family":"helvical", "font-weight": "bold", "color": "#893101"}}>Automated</p>
                  <p className='para'style={{"font-size":"20px", "margin-left":"15px", "margin-top":"-18px", "font-family":"helvical"}}>We use cutting-edge technology to run our services. Our data delivery and wallet funding is automated.</p>
                  </div>
                  <div className='card'>
                  <img src="assets/customer.png" alt="" className='Imagell' />
                  <p className=''style={{"font-size":"20px", "margin-left":"15px", "font-family":"helvical", "font-weight": "bold", "color": "#893101"}}>Customer Support</p>
                  <p className='para'style={{"font-size":"20px", "margin-left":"15px", "margin-top":"-18px", "font-family":"helvical"}}>Our customers are premium to us, hence satisfying them is our topmost priority. Our customer service is just a click away</p>
                  </div>
                 
                </div>
             
                </div>
                <div class="column right">
                    <div class="text2" style={{"fontWeight": "bolder", "color": "#893101"}}>WE PROVIDE AWESOME SERVICES</div>
                    <p className='text-center'style={{ "color":"gray"}}>Certain things are hard 😓but making payments shouldn't be one of them 😋💗.ORATECH helps you make payments for services you enjoy right from the comfort of your home or office. The experience of total 
                      convenience,fast service delivery and easy payment is just at your fingertips.</p>
                      <div className='Topup'>
                      <p className='text-center PP'>1. Airtime Topup, Buy Data 😋💗. </p>
                      <p className='text-center PP'>2. Bulk Sms, Cable Subscription 😋💗. </p>
                      </div>
          
           
                </div>
            </div>
        </div>
    </section>
    
  )
}

export default About